import event from '@/event-bus/event';
import dataRoamingApi from '@/api/dataRoaming/dataRoamingApi'

export default {
  name: 'switch-data-roaming-alert',
  mixins: [],
  extends: {},
  components: {},
  props: ['dataRoamFlagSwitch'],
  data() { 
    return {
        progress: {
            value: 0,
            msg: '',
        },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.init();
  },
  updated() {},
  beforeDestroy() {},
  methods: {
    async init(){
        // 無需彈出告警”舊的預約將會全部刪除”且dataRoamFlag = N，直接執行開啟大開關
        if(!this.dataRoamFlagSwitch.showReservationWarn && this.dataRoamFlagSwitch.dataRoamFlag == 'N'){
            this.switchDataRoaming();
        }
    },
    async switchDataRoaming(){
       
        // 彈跳式窗關閉
        this.$emit('close');
        // 若dataRoamFlag 不為N or Y，則return
        if(!(this.dataRoamFlagSwitch.dataRoamFlag == 'N' || this.dataRoamFlagSwitch.dataRoamFlag == 'Y' )){
          return;
        }

        // 打開loading
        if(this.dataRoamFlagSwitch.dataRoamFlag == 'N'){
          this.setProgress(this.progress.value += 10, '漫遊開關開啟中，請稍候')
        }else{
          this.setProgress(this.progress.value += 10, '漫遊開關關閉中，請稍候')
        }
        this.$bus.$emit(event.progress, this.progress);

        // 執行開啟/關閉大開關
        let dataRoamingSwitch = await dataRoamingApi.switchDataRoaming();
        if(!dataRoamingSwitch){
            // 關閉loading
            this.$bus.$emit(event.progressClose);
            return;
        }

        let counter = 0 // 計數器，
        // 每5秒共8次檢查大開關狀態
        let getDataBasicStatusInterval = await setInterval(async () => {

            if(counter < 8){
                // 查詢大開關狀態
                let dataBasicStatus = await dataRoamingApi.getDataBasicStatus();

                // 已開啟/關閉大開關
                if (dataBasicStatus.dataRoamFlag != this.dataRoamFlagSwitch.dataRoamFlag) {
                    clearInterval(getDataBasicStatusInterval);
                    this.setProgress(100, '優惠服務設定完成')
                    this.$bus.$emit(event.progress, this.progress);
                    this.$router.push({ name: 'gt-success', params: { returnName: 'data-roaming', title: '國際數據漫遊服務', msg: '國際數據漫遊服務已設定成功' }});
                    // 關閉loading
                    this.$bus.$emit(event.progressClose);
                }
                else{
                    this.$bus.$emit(event.progressValue, this.progress.value += 10);
                    counter++;
                }
            }
            // 查詢大開關失敗
            else{
                // 關閉loading
                this.$bus.$emit(event.progressClose);
                clearInterval(getDataBasicStatusInterval);
                this.$router.push({ name: 'gt-error', params: { returnName: 'data-roaming', msg: '國際數據漫遊服務設定失敗' }})
                return;
            }
        }, 5000);
    },
    setProgress(value, msg){
        this.progress.value = value;
        this.progress.msg = msg;
    },
    close() {
        this.$emit('close');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/service/alert/switchDataRoaming-alert.js